package fr.labodoc.domain.labodoc.common

enum class NotificationFrequency {
  Daily,
  Weekly
}
